import axios from 'axios';
import { getAPIHost, getExpressAPIHost } from '../../utils';
import Split from '../split';

const downloadDropoffSlips = (month, year) =>
    new Promise((resolve, reject) => {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const host = useExpress ? getExpressAPIHost() : getAPIHost();
        // Split-gate both host AND path: Express uses /slip/download-dropoff-slips/...;
        // LoopBack uses the un-namespaced /download-dropoff-slips/...
        const path = useExpress ? `/slip/download-dropoff-slips/${year}/${month}` : `/download-dropoff-slips/${year}/${month}`;
        const request = axios.get(`${host}${path}`, { responseType: 'arraybuffer' });
        request
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to download dropoff slips'));
            });
    });

export default downloadDropoffSlips;
